import React, { createContext, useMemo } from 'react';
interface AssessmentProviderProps {
  serviceURL?: {
    normal: string;
    CDN: string;
  };
  serviceEnvironment: string;
  children: React.ReactNode | React.ReactNode[];
}

interface AssessmentContextInterface {
  serviceURL: {
    normal: string;
    CDN: string;
  };
  serviceEnvironment: string;
}
/* We originally had two URLs, to allow for a CloudFront CDN to optimize traffic for Standards-based Practice
*  But that feature is no longer our happy path and we don't believe CloudFront was necessarily helping anyway
*  We leave the extra CDN variable as a placeholder in case we want to revisit the approach
*  If the 4x configuration triggers you too and no one knows what this comment is about any more, you are safe to refactor
*/
const assessmentBaseUrl = '//api.chalktalk.com';
const AssessmentContext: React.Context<AssessmentContextInterface> =
  createContext<AssessmentContextInterface>({
    serviceEnvironment: 'production',
    serviceURL: {
      CDN: assessmentBaseUrl,
      normal: assessmentBaseUrl,
    },
  });

const AssessmentProvider: React.FC<AssessmentProviderProps> = ({
  serviceURL = {
    CDN: assessmentBaseUrl,
    normal: assessmentBaseUrl,
  },
  serviceEnvironment = 'production',
  children,
}) => {
  const value = useMemo(
    () => ({
      serviceEnvironment,
      serviceURL,
    }),
    [serviceURL, serviceEnvironment],
  );
  return (
    <AssessmentContext.Provider value={value}>{children}</AssessmentContext.Provider>
  );
};
export default React.memo(AssessmentProvider);
// export default AssessmentProvider;
export {
  AssessmentProvider,
  AssessmentProviderProps,
  AssessmentContext,
  AssessmentContextInterface,
};
